import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '@/components/Icons/ExternalLink';
import styles from './References.module.scss';
const URLS_SHOW_MORE = 3;
const getLimit = (urlsLength, integrationLimit, showMore) => {
    const maxLimit = Math.min(urlsLength, integrationLimit);
    if (showMore) {
        // When 'showMore' is true, show up to the maximum allowed
        return maxLimit;
    }
    else {
        // Otherwise, show up to 'URLS_SHOW_MORE' or the integration limit, whichever is less
        return Math.min(maxLimit, URLS_SHOW_MORE);
    }
};
export const References = ({ urls, maxReferences, onClick }) => {
    const { t } = useTranslation();
    const [showMore, setShowMore] = useState(false);
    const handleSeeMoreClick = useCallback(() => {
        onClick({
            type: 'see_more_references',
        });
        setShowMore(true);
    }, [onClick]);
    if (!urls || urls.length === 0) {
        return null;
    }
    const maxLimit = Math.min(urls.length, maxReferences);
    const limitToShow = getLimit(urls.length, maxReferences, showMore);
    return (_jsxs("div", { className: styles.container, children: [_jsx("p", { className: styles.title, children: t('related_articles') }), _jsxs("ul", { className: styles.list, children: [urls.slice(0, limitToShow).map(({ name, external_url }) => (_jsx("li", { children: _jsxs("a", { href: external_url, target: "_blank", rel: "noreferrer", onClick: () => onClick({
                                type: 'reference_url',
                                label: name,
                                value: external_url,
                            }), children: [_jsx("span", { className: styles.url, children: name }), _jsx(ExternalLink, { color: "var(--moveo-background-color)" })] }) }, external_url))), maxLimit > URLS_SHOW_MORE && !showMore && (_jsx("button", { onClick: handleSeeMoreClick, className: styles.more, children: t('buttons.see_more') }))] })] }));
};
